"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function renderTextOrSVG(value, size) {
    if (typeof value === "function") {
        const Icon = value;
        return react_1.default.createElement(Icon, { style: { fontSize: size } });
    }
    return value;
}
function ButtonComponent({ label, leftLabel, leftLabelSize, rightLabel, rightLabelSize, size, isLoading, variant = "contained", color = "primary", ...props }) {
    return (react_1.default.createElement(style_1.StyledButton, { ...props, color: color, variant: variant, size: size, disableFocusRipple: true, disableRipple: true, disableElevation: true },
        leftLabel && (react_1.default.createElement(style_1.Label, { style: { marginRight: "12px" } }, renderTextOrSVG(leftLabel, leftLabelSize))),
        renderTextOrSVG(label),
        rightLabel && (react_1.default.createElement(style_1.Label, { style: { marginLeft: "12px" } }, renderTextOrSVG(rightLabel, rightLabelSize))),
        isLoading && react_1.default.createElement(style_1.Loading, null)));
}
exports.default = ButtonComponent;
